export default {"src":"/_next/static/media/Pomodoro_small.ecdf36fa.svg","height":193,"width":192,"blurWidth":0,"blurHeight":0};